
import { mapState } from 'vuex';
export default {
  name: 'order-page',
  props: {
    blok: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapState(['location'])
  },
  head() {
    return this.$utils.head(this.story)
  },
  beforeMount() {
    const path = this.location?.address && this.location.menu_id
      ? `/menu/${this.location.menu_id}`
      : `/locations`
    this.$nuxt.$router.push(path);
  }
}
